<div id="cfet-doc-verification-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/WatchDoc_96.png">
    <img id="verification-pending-icon" src="assets/images/WatchDoc_96.png" alt="pending verification icon">
  </picture>

  <div id="doc-verification-heading1">
    <p id="doc-heading-text1">{{cfetLabels.cfet_document_review.heading1}}</p>
    <p id="doc-heading-text2">{{cfetLabels.cfet_document_review.heading2}}</p>
    <p id="doc-heading-text3">{{cfetLabels.cfet_document_review.heading3}}</p>
  </div>

  <div id="doc-verification-desc">
    <p id="doc-desc-text1">{{cfetLabels.cfet_document_review.doc_desc1}}</p>
    <p id="doc-desc-text2">{{cfetLabels.cfet_document_review.doc_desc2}}</p>
    <p id="doc-desc-text3">{{cfetLabels.cfet_document_review.doc_desc3}}</p>
    <p id="doc-desc-text4">{{cfetLabels.cfet_document_review.doc_desc4}}</p>
  </div>

  <div id="doc-verification-footer-column">
    <div class="button-continue-profile">
      <button type="button" id="btn-continue" (click)="continueToProfile($event)" (keyup)="continueToProfile($event)"
        class="btn btn-alt btn-medium" tabindex="0">
        {{cfetButtonLabels.button_labels.continueToProfile}}</button>
    </div>
  </div>

</div>